import { writable } from 'svelte/store';

export const loginLeftBlockState = writable('buttons'); // initial state is 'buttons'
